/* eslint-disable max-len */
import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars
import {CustomComponent, Link} from '../../../common/components';

export class APITermsSection extends CustomComponent {
    constructor(props: jsx.Props, context: jsx.AppGlobals) {
        super(props, context);
    }
    render() {
        return (
            <div id="apiterms">
                <h1>API Terms</h1>
                <h3>Tenor API Terms of Service</h3>
                <h4>Last revised: March 3, 2021</h4>
                <section className="narrow">

                    <p>
                    Thank you for your interest in Google’s Tenor API Services. The &quot;<b>Tenor API Services</b>&quot;
                    means (1) the Tenor API services made available by Google, including those Tenor API services
                    made available on the Tenor Developer Site, (2) documentation, information, materials, sample
                    code and software relating to the Tenor API services that are made available on the Tenor
                    Developer Site or by Google, (3) data, content (including audiovisual content) and information
                    provided to API Clients through the Tenor API services (&quot;<b>Content</b>&quot;), and (4) the credentials
                    assigned to you and your API Clients by Google.
                    </p>

                    <div className="legal-terms">
                        <div className="terms-row level-1">
                            <div><b>1.</b></div>
                            <div>
                                <b>The Terms.</b>
                            </div>
                        </div>
                        <div className="terms-row level-3">
                            <div>a.</div>
                            <span>
                                <b>Components.</b>
                                {` To use the Tenor API Services, you must accept the  Google API Terms of Service at `}
                                <Link to="https://developers.google.com/terms/">https://developers.google.com/terms/</Link>
                                {` (or such other URL as Google may provide, the "`}<b>Google API Terms of Service</b>{`")
                                and these Tenor API Additional Terms (the "`}<b>Tenor Additional Terms</b>{`").`}
                            </span>
                        </div>
                        <div className="terms-row level-3">
                            <div>b.</div>
                            <div>
                                <b>Terms.</b>
                                {` Collectively, we refer to the Google API Terms of Service, these Tenor Additional
                                Terms, any accompanying documentation, and any applicable policies and guidelines
                                as the "`}<b>Terms</b>{`".`}
                            </div>
                        </div>
                        <div className="terms-row level-3">
                            <div>c.</div>
                            <div>
                                <b>Precedence.</b>
                                {` You agree to comply with the Terms and that the Terms control your relationship
                                with us.  To the extent that there are any conflicts, the following order of
                                precedence will apply: (i) other agreements with the parties covering the same
                                subject (for example, if you have a separate Tenor API Content Access Agreement),
                                (ii) Tenor Developer Policies, (iii) the Tenor Additional Terms, and (iv)
                                Google’s API Terms of Service.`}

                            </div>
                        </div>
                        <div className="terms-row level-3">
                            <div>d.</div>
                            <div>
                                <b>Google.</b>
                                {` We may refer to "Google" as "we", "our", or "us" in the Terms. Google may use
                                its Affiliates in connection with performing its obligations and exercising its
                                rights under the Terms.`}
                            </div>
                        </div>


                        <div className="terms-row level-1">
                            <div><b>2.</b></div>
                            <div>
                                <b>Definitions.</b>
                                {` Capitalized terms used but not defined in these Tenor Additional Terms have
                                the meaning given to them in the Google API Terms of Service.`}
                            </div>
                        </div>
                        <div className="terms-row level-3">
                            <div>a.</div>
                            <div>
                                <b>Affiliates</b>
                                {` means the entity that directly or indirectly controls, is controlled by,
                                or is under common control with, Google, including Tenor, Inc.`}
                            </div>
                        </div>
                        <div className="terms-row level-3">
                            <div>b.</div>
                            <div>
                                <b>Tenor Developer Policies</b>
                                {` means the policies relating to the Tenor API Services currently located at `}
                                <Link to="https://support.google.com/tenor">https://support.google.com/tenor</Link>
                                {`.`}
                            </div>
                        </div>
                        <div className="terms-row level-3">
                            <div>c.</div>
                            <div>
                                <b>Tenor Developer Site</b>
                                {` means the Tenor developer website including the webpages currently located at `}
                                <Link to="https://tenor.com/gifapi">https://tenor.com/gifapi</Link>
                                {`.`}
                            </div>
                        </div>


                        <div className="terms-row level-1">
                            <div><b>3.</b></div>
                            <div>
                                <b>Use of the Tenor API Services.</b>
                            </div>
                        </div>
                        <div className="terms-row level-3">
                            <div>a.</div>
                            <div>
                                <b>Permitted Commercial Uses.</b>
                                {` As long as you follow these Terms, you may use the Tenor API for the following
                                commercial uses or as otherwise described in the Tenor Developer Policies:
    `}
                            </div>
                        </div>
                        <div className="terms-row level-4">
                            <div>i.</div>
                            <div>
                                {`charging fees to access your API Client or the online service that uses your API Client;`}
                            </div>
                        </div>
                        <div className="terms-row level-4">
                            <div>ii.</div>
                            <div>
                                {`using the Tenor API to show Content on an ad-enabled API Client (such as an
                                ad-enabled app, blog, or website), subject to Section 3(c) (Prohibited Commercial Uses) below;`}
                            </div>
                        </div>
                        <div className="terms-row level-4">
                            <div>iii.</div>
                            <div>
                                {`placing your own branding on the API Client, as long as it does not interfere
                                with the display of any Content or with any Tenor Branding.`}
                            </div>
                        </div>
                        <div className="terms-row level-3">
                            <div>b.</div>
                            <div>
                                <b>Prohibited Commercial Uses.</b>
                                {` Unless you obtain Google’s prior written approval, you will not (or allow those
                                acting on your behalf to) use the Tenor API Services to sell advertising, sponsorships, or promotions on or through the Content (including pop-up ads or ads linked to from the Content).
    `}
                            </div>
                        </div>
                        <div className="terms-row level-3">
                            <div>c.</div>
                            <div>
                                <b>General Prohibitions.</b>
                                {` Your API Client will not, you will not, and you will not encourage or allow
                                your users or other third parties to do the following in connection with the Tenor API Services:
    `}
                            </div>
                        </div>
                        <div className="terms-row level-4">
                            <div>i.</div>
                            <div>
                                {`modify or replace the text, images, or other content of the Tenor search results;`}
                            </div>
                        </div>
                        <div className="terms-row level-4">
                            <div>ii.</div>
                            <div>
                                {`change the order in which Tenor search results are presented;`}
                            </div>
                        </div>
                        <div className="terms-row level-4">
                            <div>iii.</div>
                            <div>
                                {`intermix sources other than Tenor when attributing search results as Tenor search results;`}
                            </div>
                        </div>
                        <div className="terms-row level-4">
                            <div>iv.</div>
                            <div>
                                {`modify, replace, or disable links to Tenor or third-party websites provided in
                                the Tenor search results or otherwise provided through the Tenor Services;`}
                            </div>
                        </div>
                        <div className="terms-row level-4">
                            <div>v.</div>
                            <div>
                                {`modify, replace, interfere with, or block advertisements placed by Tenor in
                                the Tenor search results or Content;`}
                            </div>
                        </div>
                        <div className="terms-row level-4">
                            <div>vi.</div>
                            <div>
                                {`promote or condone violence, or incite hate against an individual or group
                                based on any characteristic that is associated with systemic discrimination or
                                marginalization (including race, ethnicity, nationality, religion, disability,
                                age, veteran status, sexual orientation, gender, or gender identity);`}
                            </div>
                        </div>
                        <div className="terms-row level-4">
                            <div>vii.</div>
                            <div>
                                {`promote, encourage, or support (A) graphic or gratuitous violence; (B)
                                dangerous activities; (C) terrorism; (D) suicide or self-harm; (E) prostitution,
                                escort services, and similar offerings; (F) bullying, blackmail, or revenge;
                                (G) violating any person’s privacy or publicity rights; or`}
                            </div>
                        </div>
                        <div className="terms-row level-4">
                            <div>viii.</div>
                            <div>
                                {`display sexually-explicit imagery (including pornographic content or behavior).`}
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}
